import React, { useEffect, useState } from 'react';
import GroupAccountDetails from './GroupAccountDetails';
import { getGroupAccountAddress } from '../../redux/Reducers/commonApis';
import { useDispatch } from 'react-redux';
import { setGroupDataAction } from '../../redux/Actions/GroupActions';

function GroupAccount() {
  const dispatch = useDispatch();
  const currentURL = new URL(window.location.href);
  const urlParams = new URLSearchParams(currentURL.search);
  const [loading, setLoading] = useState(false);
  const token = urlParams.get('token');
  const getGroupAccountAddressFn = (id) => {
    setLoading(true);
    const response = getGroupAccountAddress(id);
    response.then((res) => {
      if (res?.status === 200 || res?.status === 201) {
        dispatch(setGroupDataAction(res?.data));
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };
  useEffect(() => {
    token && getGroupAccountAddressFn(token);
  }, [token]);
  return <GroupAccountDetails token={token} loading={loading} />;
}

export default GroupAccount;
